







import {Component, Vue} from "vue-property-decorator";

@Component
export default class BookItem extends Vue {
  goToForm(): void {
    this.$router.push({name: "Form1"});
  }
}
